export default "__VITE_ASSET__Bh5wuRmp__"